import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 零件列表
export const setDigitalMeshes: Mutation<IModuleState> = (state, payload) => {
  state.list.data = payload.data;
  state.list.pageNum = payload.pageNum;
  state.list.pageSize = payload.pageSize;
  state.list.total = payload.total;
  state.list.loading = !!payload.loading;
};

// 详情
export const setDigitalMeshDetail: Mutation<IModuleState> = (state, payload) => {
  state.detail.data = payload.data;
  state.detail.loading = !!payload.loading;
};

// 插槽可用的定制材料列表
export const setSlotMaterials: Mutation<IModuleState> = (state, payload) => {
  state.slotMaterials.data = payload.data;
  state.slotMaterials.loading = !!payload.loading;
};

// 可用的连接件列表
export const setJointPage: Mutation<IModuleState> = (state, payload) => {
  state.jointPage.data = payload.data;
  state.jointPage.pageNum = payload.pageNum;
  state.jointPage.pageSize = payload.pageSize;
  state.jointPage.total = payload.total;
  state.jointPage.loading = !!payload.loading;
};

// 零件类型列表
export const setComponentTypes: Mutation<IModuleState> = (state, payload) => {
  state.componentTypes.data = payload.data;
  state.componentTypes.loading = !!payload.loading;
};

// 光源轴向类型列表
export const setAxialTypes: Mutation<IModuleState> = (state, payload) => {
  state.axialTypes.data = payload.data;
  state.axialTypes.loading = !!payload.loading;
};

// 光源摆放类型列表
export const setIlluminantTypes: Mutation<IModuleState> = (state, payload) => {
  state.illuminantTypes.data = payload.data;
  state.illuminantTypes.loading = !!payload.loading;
};

// 缩略图
export const setDigitalMeshThumb: Mutation<IModuleState> = (state, payload) => {
  state.thumb.data = payload.data;
  state.thumb.loading = payload.loading;
};

// 价格弹窗
export const setPriceDialog: Mutation<IModuleState> = (state, payload) => {
  state.priceDialog.data = payload.data;
  state.priceDialog.visible = !!payload.visible;
  state.priceDialog.loading = !!payload.loading;
};

// 模型详情弹窗
export const setUeDialog: Mutation<IModuleState> = (state, payload) => {
  state.ueDialog.fullpath = payload.fullpath;
  state.ueDialog.visible = !!payload.visible;
  state.ueDialog.loading = !!payload.loading;
};

// confirm 弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.name = payload.name;
  state.confirm.title = payload.title;
  state.confirm.content = payload.content;
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
};

// 设置列表搜索条件
export const setSearchParams: Mutation<IModuleState> = (state, payload) => {
  state.searchParams = payload;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = payload;
};


// 模型信息
export const setModelInfo: Mutation<IModuleState> = (state, payload) => {
  state.modelInfo.data = payload.data;
  state.modelInfo.loading = !!payload.loading;
};
